import { render } from "./AboutHeroSection.vue?vue&type=template&id=3ba36c4e&scoped=true"
import script from "./AboutHeroSection.vue?vue&type=script&lang=js"
export * from "./AboutHeroSection.vue?vue&type=script&lang=js"

import "./AboutHeroSection.vue?vue&type=style&index=0&id=3ba36c4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba36c4e"]])

export default __exports__